<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1>Copyright Information ©</h1>
<p>Stephan Swart 2023</p><br/>
<p>The right of Stephan Swart to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p><br/>
<p>All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p><br/>
<p>Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p><br/>
<p>This is a work of fiction. Names, characters, businesses, places, events, locales, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.</p><br/>
<p>A CIP catalogue record for this title is available from the British Library.</p><br/>
<p>ISBN 9781398486362 (Paperback)</p>
<p>ISBN 9781398486379 (ePub e-book)</p><br/>
<p>www.austinmacauley.com</p><br/>
<p style="margin-bottom:-5px;">First Published 2023</p>
<p>Austin Macauley Publishers Ltd<sup>®</sup></p>
<p>1 Canada Square</p>
<p>Canary Wharf</p>
<p>London</p>
<p>E14 5AA</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?632e2d0e